import { kovanFarmingPools } from "./../eth/contracts/contracts";
import PriceStore from "stores/PriceStore";
import { action, observable, runInAction } from "mobx";
import GovernanceStore from "./GovernanceStore";
import UserStore from "./UserStore";
import VaultStore from "./VaultStore";
import debounce from "lodash.debounce";
import NFTStore from "./NFTStore";
import PoolStore from "./PoolStore";

class EthStore {
  @observable network: string = "kovan";
  @observable currentBlock: number = 0;
  @observable provider: any = null;
  @observable signer: any = undefined;
  @observable account: string = "";

  @action initialize = async (account: string, provider: any) => {
    let accountChange = false;
    if (this.account !== "") {
      accountChange = true;
    }
    this.account = account;
    this.provider = provider;
    provider.off("block");
    provider.on("block", debounce(this.setCurrentBlock, 1000, { leading: false, trailing: true }));
    const signer = await provider.getSigner();
    runInAction(() => (this.signer = signer));
    if (!accountChange) {
      return true;
    } else {
      await VaultStore.fetchAllPoolData();
      await VaultStore.fetchUserPoolData("0");
      await NFTStore.initialize(this.network);
      await UserStore.initialize();
      await GovernanceStore.initialize();
      kovanFarmingPools.map((pool) => PoolStore.fetchPoolData(pool));
    }
  };

  @action changeNetwork = (network: string) => {
    this.network = network;
  };

  @action setCurrentBlock = async (blockNumber: number) => {
    if (this.currentBlock <= blockNumber + 2) {
      this.currentBlock = blockNumber;
      await UserStore.fetchAllBalances();
      await VaultStore.fetchAllPoolData();
      await VaultStore.fetchUserPoolData("0");
      await GovernanceStore.getUserData();
      await PriceStore.fetchPrices(this.provider);
      kovanFarmingPools.map((pool) => PoolStore.fetchPoolData(pool));
    }
  };
}

export default new EthStore();
